import { useEffect, useState } from "react";
import {
  CompetitionType,
  KoreaRegion,
  WorldRegion,
} from "../../../api/competition";
import { useCompetitionContext } from "./hook/competitionContext";
import {
  CompetitionBodyWrapper,
  CompetitionHorizontalBar,
  CompetitionTournamentDropDownBox,
  CompetitionTournamentMainBanner,
  CompetitionTournamentSelector,
  CompetitionTournamentWrapper,
  Header,
} from "./styles";
import CompetitionItem from "./component/competitionItem";
import Pagination from "../../../components/web/Pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { useHistory } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { insetState } from "../../../recoil/inset";
import CompetitionFilterHeader from "./component/competitionFilterHeader";
import { RunnerTournamentWrapper } from "../FranchisePubs/style";
import { getFranchisePub } from "../../../api/cafe";

const Schedule = () => {
  const {
    competitionList,
    page,
    setPage,
    type,
    lastPage,
    showCountByType,
    getKoreanRegion,
    region,
    setRegion,
  } = useCompetitionContext();
  const [isRegionSelect, setIsRegionSelect] = useState(false);
  const [currenBannerIndex, setCurrentBannerIndex] = useState(0);
  const inset = useRecoilValue(insetState);
  const history = useHistory();
  const [runnerPubId, setRunnerPubId] = useState<number | null>(null);

  const getPubList = async () => {
    const res = await getFranchisePub();
    const runnerPub = res.list.find((item) => item.pubType === "RUNNER");
    if (runnerPub) {
      setRunnerPubId(runnerPub.id);
    }
  };

  useEffect(() => {
    getPubList();
  }, []);

  const regionList =
    type === CompetitionType.INTERNATIONAL
      ? Object.values(WorldRegion)
      : Object.values(KoreaRegion);

  return (
    <CompetitionTournamentWrapper isApp={inset}>
      <Header isApp={inset}>
        <div className="close" onClick={() => history.push("/")}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12 19L5 12M5 12L12 5M5 12H19"
              strokeWidth="1.7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="title">토너먼트 스케줄</div>
      </Header>
      <div className="banner-swiper">
        <RunnerTournamentWrapper
          onClick={() => {
            history.push(`/store/${runnerPubId}?type=PREMIUM`);
          }}
        >
          <div className="title">
            RABBIT FESTIVAL <br />
            WITH RUNNER PUB
          </div>
          <div className="description">진행중인 대회를 확인해보세요!</div>
        </RunnerTournamentWrapper>
      </div>
      <CompetitionFilterHeader
        setIsRegionSelect={setIsRegionSelect}
        isRegionSelect={isRegionSelect}
      />
      <CompetitionHorizontalBar />
      <CompetitionBodyWrapper>
        <div className="header">
          {showCountByType()}
          <CompetitionTournamentSelector
            onClick={() => {
              setIsRegionSelect(!isRegionSelect);
            }}
          >
            <div className="value">{`${getKoreanRegion(region)}`}</div>
            <img src="/image-web/competition/drop-down.svg" alt="drop-down" />
            {isRegionSelect && (
              <CompetitionTournamentDropDownBox
                style={{ left: "-25px", maxHeight: "250px" }}
              >
                {regionList.map((item, index) => (
                  <div
                    key={index}
                    className={`item ${
                      region === null && item === "ALL"
                        ? "active"
                        : region === item
                        ? "active"
                        : ""
                    }`}
                    onClick={() => {
                      if (item === "ALL") {
                        setRegion(null);
                      } else {
                        setRegion(item);
                      }

                      setIsRegionSelect(false);
                    }}
                  >
                    {getKoreanRegion(item)}
                  </div>
                ))}
              </CompetitionTournamentDropDownBox>
            )}
          </CompetitionTournamentSelector>
        </div>
        <div className="list-wrapper">
          {competitionList.map((item, index) => (
            <CompetitionItem key={index} data={item} />
          ))}
        </div>

        {lastPage > 1 && (
          <Pagination
            currentPage={page}
            totalPages={lastPage}
            onPageChange={setPage}
          />
        )}
      </CompetitionBodyWrapper>
    </CompetitionTournamentWrapper>
  );
};

export default Schedule;
